module.exports = __webpack_public_path__ + "img/vipgroup_businessblue_icon.ceec5980.png";